import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let CommonApi = {
    confirmEmail: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-user/secure/${payload.type}/confirm-email`,
            method: 'POST',
            body: payload.body,
        }, callback);
    },

}

export default CommonApi
